import React from "react";
import { Card } from "@/components/Card";
import { DynamicContent } from "@/components/DynamicContent";
import { useTheme } from "@/hooks/useTheme";
import { logger } from "@/utils/logger";
import { ErrorBoundary } from "react-error-boundary";
import { Error } from "@/containers/FileRepair/components/Error";
import { FileRepairContainer } from "@/containers/FileRepair/FileRepairContainer";

export const FileRepair: React.FC = () => {
  const { bp } = useTheme();

  return (
    <DynamicContent>
      <Card
        customStyle={{
          minHeight: 380,
          maxWidth: 560,
          position: "relative",
          [bp.FROM_TABLET]: {
            minHeight: 470,
            padding: "25px 30px",
          },
          [bp.FROM_DESKTOP]: {
            marginTop: 50,
          },
        }}
      >
        <ErrorBoundary
          FallbackComponent={Error}
          onError={error => {
            logger.error(error);
          }}
        >
          <FileRepairContainer />
        </ErrorBoundary>
      </Card>
    </DynamicContent>
  );
};
